// utils/role-guard.tsx
import React from "react";
import { Navigate } from "react-router-dom";
import { getDashboardPathForRole } from "./function";

type Role = "RECOMMENDER" | "ADVERTISER" | "ADMIN" | "SUPER_ADMIN";

interface RoleGuardProps {
  role: Role;
  children: React.ReactNode;
}

const RoleGuard: React.FC<RoleGuardProps> = ({ role, children }) => {
  const userType = localStorage.getItem("user-type");

  // Logged in, but with a different role than this route requires — send
  // them to their own dashboard instead of bouncing to /login.
  if (userType !== role) {
    return <Navigate to={getDashboardPathForRole(userType)} replace />;
  }

  return <>{children}</>;
};

export default RoleGuard;
